/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DeviceModelIncidentRulesControllerFindAllV1Params = {
  /**
   * Items per page
   */
  limit?: number;
  /**
   * Pagination offset
   */
  offset?: number;
};
